import React, { FC, memo } from "react";
import Select, { components, MenuPlacement } from "react-select";
import DropArrows from "~/components/Icons/icon-drop";
import s from "~/shared/ui/Fields/Select/Select.less";
import { useTranslation } from "react-i18next";

import { mergeReactSelectSelectedFirst } from "~/shared/lib/selectedFirstOptions";

interface IProps {
  onChange?;
  value?;
  defaultValue?;
  isLoading?: boolean;
  disabled?: boolean;
  menuCustom?: boolean;
  isNoLabel?: boolean;
  isHeight?: boolean;
  error?: string;
  required?: boolean;
  isMulti?: boolean;
  isSearchable?: boolean;
  options?: object[];
  custom?: boolean;
}

const CustomSelect: FC<IProps> = ({
  onChange,
  value,
  defaultValue,
  error,
  isLoading = false,
  disabled = false,
  isHeight = false,
  isNoLabel = false,
  menuCustom = false,
  isSearchable = false,
  isMulti = false,
  required = false,
  custom = false,
  options = [],
}) => {
  const { t } = useTranslation();
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <DropArrows />
      </components.DropdownIndicator>
    );
  };

  const { Option } = components;
  const IconOption = (props) => (
    <Option {...props}>
      {props.data.icon && <span> {props.data.icon} </span>}
      {props.data.label}
    </Option>
  );

  const customSingleValue = ({ data }) => (
    <div className="single-value">
      {data.icon && (
        <span className={s.input_select__icon}>
          {" "}
          <img src={data.icon} />
        </span>
      )}
      {!data.icon && <span>{data.label}</span>}
    </div>
  );

  const customOption = (props) => (
    <Option {...props}>
      {props.data.icon && (
        <span className={s.input_select__icon_option}>
          <img src={props.data.icon} />
          {/*{data.icon}*/}
        </span>
      )}
      {props.data.icon ? t(`zd.${props.data.label}`) : props.data.label}
    </Option>
  );

  const customClassNames = {
    container: (provided) => ({
      ...provided,
      width: "100%",
    }),
    control: (provided, state) => ({
      ...provided,
      minHeight: "15px",
      width: "100%",
      height: isHeight ? "auto" : "25px",
      borderRadius: "6px",
      border: "none",
      fontSize: "10px",
      fontFamily: "LADA_Pragmatica",
      webkitBoxShadow: state.isFocused
        ? "0 0 3px rgb(255 158 27)"
        : "0 1px 3px rgba(16, 15, 14, 0.25)",
      boxShadow: state.isFocused
        ? "0 0 3px rgb(255 158 27)"
        : error && value.value === null
        ? "0 1px 3px rgba(255, 0, 0, 0.75)"
        : "0 1px 3px rgba(16, 15, 14, 0.25)",
      cursor: "pointer",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "22px",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 2,
      left: isNoLabel ? "0" : "-100%",
      width: menuCustom ? "100%" : "170px",
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isFocused ? "white" : "#65727c",
      fontSize: "11px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      alignItems: "flex-start",
      flexWrap: isMulti ? "nowrap" : "wrap",
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none",
    }),
    singleValue: (provided) => ({
      ...provided,
    }),
    Input: (provided) => ({
      ...provided,
      display: "none!important",
    }),
  };

  const customTheme = (theme) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary25: "#f17830",
      primary: "#ff9e1b",
      danger: "#a64921",
      dangerLight: "#f5dcba",
    },
  });

  // Выбранные опции всегда вверху списка.
  const sortedOptions = mergeReactSelectSelectedFirst(
    options as { value?: React.Key }[],
    value ?? defaultValue,
  );

  return (
    <>
      <Select
        theme={customTheme}
        styles={customClassNames}
        components={{
          DropdownIndicator,
          Option: customOption,
          SingleValue: customSingleValue,
        }}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        placeholder={isMulti && t("zd.isMultiPlace")}
        options={sortedOptions}
        isMulti={isMulti}
        isDisabled={disabled}
        isClearable={false}
        isSearchable={true}
        isLoading={isLoading}
      />
      {error && <span className={s.error_text}>{error}</span>}
    </>
  );
};
export default memo(CustomSelect);
